var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCalendar = function SvgCalendar(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.3,
    d: "M6.4 3v1.6h-.8c-.888 0-1.6.712-1.6 1.6v11.2c0 .88.712 1.6 1.6 1.6h4.88a5.57 5.57 0 0 0 3.92 1.6c3.096 0 5.6-2.504 5.6-5.6a5.57 5.57 0 0 0-1.6-3.92V6.2a1.6 1.6 0 0 0-1.6-1.6H16V3h-1.6v1.6H8V3zm-.8 3.2h11.2v1.6H5.6zm0 3.2h11.2v.536a5.6 5.6 0 0 0-2.4-.536A5.596 5.596 0 0 0 8.8 15c0 .856.192 1.672.536 2.4H5.6zm8.8 1.72A3.88 3.88 0 0 1 18.28 15a3.88 3.88 0 0 1-3.88 3.88A3.88 3.88 0 0 1 10.52 15a3.88 3.88 0 0 1 3.88-3.88m-.8 1.48v2.952l2.552 1.472.6-1.04-1.952-1.128V12.6z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);
export { ForwardRef as ReactComponent };